import type { Channel } from 'stream-chat'

import type { ChatType } from 'src/shared/schemas/chats/chat-data'

export const getChatType = (channel: Channel): ChatType => {
  return channel.type === 'messaging'
    ? 'referral'
    : channel.data?.category === 'partner_match'
    ? 'partner-match'
    : channel.data?.category === 'sneak'
    ? 'sneak'
    : 'network'
}
